<template>
    <div>
        {{ position.latitude + ',' + position.longitude }}
    </div>
</template>
<script>
import { firstApi } from '../http/api.js'
export default {
    data() {
        return {
            position: {
                latitude: '',
                longitude: ''
            }
        }
    },
    mounted() {
        //this.getUrlPosition();
        this.geturl();
    },
    methods: {
        getUrlPosition() {
            var url = window.location.href;

            //获取经纬度参数  http://192.168.1.101:8080//newHttp?latitude=28.176357421875&longitude=112.9810595703125#wechat_redirect
            var latitude = url.split('latitude=')[1].split('&')[0];
            var longitude = url.split('longitude=')[1].split('#')[0];
            this.position = {
                latitude: latitude,
                longitude: longitude
            }
            console.log('latitude:', latitude, 'longitude:', longitude)
        },
        geturl() {
            const MetaInfo = window.getMetaInfo();
            MetaInfo.TerminalType = "H5"
            firstApi.initFaceVerifyBack({metaInfovo:MetaInfo}).then((e) => {
                console.log(e)
                if (e.code == 1) {
                     window.location.href = e.data.certifyUrl;
                }
               // console.log(e)
            });
        }

    }
}
</script>
<style></style>